import * as XLSX from "xlsx";

export const exportExcelFile = ({
  sheetData,
  fileName,
  columnWidths = [],
  rowHeight = 20,
}) => {
  if (!sheetData?.length) return;

  const EXCEL_TYPE =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const EXCEL_EXTENSION = ".xlsx";

  const worksheet = XLSX.utils.json_to_sheet(sheetData);

  if (columnWidths.length) {
    worksheet["!cols"] = columnWidths.map((width) => ({ wch: width }));
  }

  worksheet["!rows"] = Array.from({ length: sheetData.length + 1 }, () => ({
    hpx: rowHeight,
  }));

  const workbook = {
    Sheets: {
      data: worksheet,
    },
    SheetNames: ["data"],
  };

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], { type: EXCEL_TYPE });
  const url = URL.createObjectURL(blob);

  var excelFile = document.createElement("a");
  excelFile.href = url;
  excelFile.download = `${fileName} ${EXCEL_EXTENSION}`;
  excelFile.click();
};
